import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

/** Franja sticky de urgencia mostrando el countdown a la entrada en vigencia (1-dic-2026). */
export default function UrgencyBanner() {
  const [dias, setDias] = useState(() => calcDias());

  useEffect(() => {
    const id = setInterval(() => setDias(calcDias()), 60 * 60 * 1000); // 1h
    return () => clearInterval(id);
  }, []);

  if (dias <= 0) return null;

  return (
    <div
      data-testid="urgency-banner"
      className="w-full bg-[#0b1220] text-amber-100 border-b border-amber-400/20"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-center gap-3 text-[13px] sm:text-sm font-medium">
        <AlertTriangle className="w-4 h-4 text-amber-300 shrink-0" />
        <span className="whitespace-normal">
          Ley 21.719 · Entra en vigencia el 1 de diciembre de 2026 ·{" "}
          <strong data-testid="urgency-days" className="text-amber-300">quedan {dias} días</strong>
        </span>
      </div>
    </div>
  );
}

function calcDias() {
  const target = new Date("2026-12-01T00:00:00-03:00").getTime();
  const now = Date.now();
  return Math.max(0, Math.ceil((target - now) / (1000 * 60 * 60 * 24)));
}
